import { cn } from '@/shared/lib/utils';
import { SelectorPageSizeControl } from './SelectorPageSizeControl';
import { SelectorPagination } from './SelectorPagination';

export interface SelectorPagingControlsProps {
  currentPage: number;
  totalPages: number;
  pageSize: number;
  onPageChange: (page: number) => void;
  onPageSizeChange: (size: number) => void;
  pageSizeOptions?: readonly number[];
  paginationVariant?: 'boxed' | 'plain';
  layout?: 'grouped' | 'modalGrid';
}

export function SelectorPagingControls({
  currentPage,
  totalPages,
  pageSize,
  onPageChange,
  onPageSizeChange,
  pageSizeOptions,
  paginationVariant = 'boxed',
  layout = 'grouped',
}: SelectorPagingControlsProps) {
  const pageSizeControl = (
    <SelectorPageSizeControl
      pageSize={pageSize}
      onPageSizeChange={onPageSizeChange}
      pageSizeOptions={pageSizeOptions}
      variant="minimal"
    />
  );

  const pagination = (
    <SelectorPagination
      currentPage={currentPage}
      totalPages={totalPages}
      onPageChange={onPageChange}
      variant={paginationVariant}
    />
  );

  if (layout === 'modalGrid') {
    return (
      <>
        <div className="justify-self-start">{pageSizeControl}</div>
        <div className="justify-self-center">{pagination}</div>
      </>
    );
  }

  return (
    <div className={cn('gap-phx-4 flex items-center')}>
      {pagination}
      {pageSizeControl}
    </div>
  );
}
